import { render, staticRenderFns } from "./list05.vue?vue&type=template&id=222a3224&scoped=true&"
import script from "./list05.js?vue&type=script&lang=js&"
export * from "./list05.js?vue&type=script&lang=js&"
import style0 from "./list05.vue?vue&type=style&index=0&id=222a3224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a3224",
  null
  
)

export default component.exports